const WomensProduct = ({ shopProduct }) => {
  console.log(shopProduct);

  return (

    <>
      <div className="row property__gallery">

        {/* <div className="col-lg-3 col-md-4 col-sm-6 mix women"> */}
        <div className={`${(shopProduct) ? 'col-lg-4 col-md-6' : 'col-lg-3 col-md-4 col-sm-6 mix women'}`}>
          <div className="product__item">
            <div
              className="product__item__pic set-bg"
              style={{
                backgroundImage: "url(assets/img/product/product-1.jpg)",
              }}
            >
              <div className="label new">New</div>
              <ul className="product__hover">
                <li>
                  <a
                    href="assets/img/product/product-1.jpg"
                    className="image-popup"
                  >
                    <span className="arrow_expand"></span>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <span className="icon_heart_alt"></span>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <span className="icon_bag_alt"></span>
                  </a>
                </li>
              </ul>
            </div>
            <div className="product__item__text">
              <h6>
                <a href="#">Buttons tweed blazer</a>
              </h6>
              <div className="rating">
                <i className="fa fa-star"></i>
                <i className="fa fa-star"></i>
                <i className="fa fa-star"></i>
                <i className="fa fa-star"></i>
                <i className="fa fa-star"></i>
              </div>
              <div className="product__price">$ 59.0</div>
            </div>
          </div>
        </div>
        <div className={`${(shopProduct) ? 'col-lg-4 col-md-6' : 'col-lg-3 col-md-4 col-sm-6 women men kid accessories cosmetic'}`}>
          <div className="product__item">
            <div
              className="product__item__pic set-bg"
              style={{
                backgroundImage: "url(assets/img/product/product-7.jpg)",
              }}
            >
              <ul className="product__hover">
                <li>
                  <a
                    href="assets/img/product/product-7.jpg"
                    className="image-popup"
                  >
                    <span className="arrow_expand"></span>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <span className="icon_heart_alt"></span>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <span className="icon_bag_alt"></span>
                  </a>
                </li>
              </ul>
            </div>
            <div className="product__item__text">
              <h6>
                <a href="#">Contrasting sunglasses</a>
              </h6>
              <div className="rating">
                <i className="fa fa-star"></i>
                <i className="fa fa-star"></i>
                <i className="fa fa-star"></i>
                <i className="fa fa-star"></i>
                <i className="fa fa-star"></i>
              </div>
              <div className="product__price">$ 59.0</div>
            </div>
          </div>
        </div>
     

        <div className={`${(shopProduct) ? 'col-lg-4 col-md-6' : 'col-lg-3 col-md-4 col-sm-6 women men kid accessories cosmetic'}`}>
          <div className="product__item sale">
            <div
              className="product__item__pic set-bg"
              style={{
                backgroundImage: "url(assets/img/product/product-6.jpg)",
              }}
            >
              <div className="label sale">Sale</div>
              <ul className="product__hover">
                <li>
                  <a
                    href="assets/img/product/product-6.jpg"
                    className="image-popup"
                  >
                    <span className="arrow_expand"></span>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <span className="icon_heart_alt"></span>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <span className="icon_bag_alt"></span>
                  </a>
                </li>
              </ul>
            </div>
            <div className="product__item__text">
              <h6>
                <a href="#">Tropical Kimono</a>
              </h6>
              <div className="rating">
                <i className="fa fa-star"></i>
                <i className="fa fa-star"></i>
                <i className="fa fa-star"></i>
                <i className="fa fa-star"></i>
                <i className="fa fa-star"></i>
              </div>
              <div className="product__price">
                $ 49.0 <span>$ 59.0</span>
              </div>
            </div>
          </div>
        </div>
        <div className={`${(shopProduct) ? 'col-lg-4 col-md-6' : 'col-lg-3 col-md-4 col-sm-6 mix accessories'}`}>
          <div className="product__item">
            <div
              className="product__item__pic set-bg"
              style={{
                backgroundImage: "url(assets/img/product/product-3.jpg)",
              }}
            >
              <div className="label stockout">out of stock</div>
              <ul className="product__hover">
                <li>
                  <a
                    href="assets/img/product/product-3.jpg"
                    className="image-popup"
                  >
                    <span className="arrow_expand"></span>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <span className="icon_heart_alt"></span>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <span className="icon_bag_alt"></span>
                  </a>
                </li>
              </ul>
            </div>
            <div className="product__item__text">
              <h6>
                <a href="#">Cotton T-Shirt</a>
              </h6>
              <div className="rating">
                <i className="fa fa-star"></i>
                <i className="fa fa-star"></i>
                <i className="fa fa-star"></i>
                <i className="fa fa-star"></i>
                <i className="fa fa-star"></i>
              </div>
              <div className="product__price">$ 59.0</div>
            </div>
          </div>
        </div>
        <div className={`${(shopProduct) ? 'col-lg-4 col-md-6' : 'col-lg-3 col-md-4 col-sm-6 mix women'}`}>
          <div className="product__item">
            <div
              className="product__item__pic set-bg"
              style={{
                backgroundImage: "url(assets/img/product/product-1.jpg)",
              }}
            >
              <div className="label new">New</div>
              <ul className="product__hover">
                <li>
                  <a
                    href="assets/img/product/product-1.jpg"
                    className="image-popup"
                  >
                    <span className="arrow_expand"></span>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <span className="icon_heart_alt"></span>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <span className="icon_bag_alt"></span>
                  </a>
                </li>
              </ul>
            </div>
            <div className="product__item__text">
              <h6>
                <a href="#">Buttons tweed blazer</a>
              </h6>
              <div className="rating">
                <i className="fa fa-star"></i>
                <i className="fa fa-star"></i>
                <i className="fa fa-star"></i>
                <i className="fa fa-star"></i>
                <i className="fa fa-star"></i>
              </div>
              <div className="product__price">$ 59.0</div>
            </div>
          </div>
        </div>
        
       
        <div className={`${(shopProduct) ? 'col-lg-4 col-md-6' : 'col-lg-3 col-md-4 col-sm-6 women men kid accessories cosmetic'}`}>
          <div className="product__item">
            <div
              className="product__item__pic set-bg"
              style={{
                backgroundImage: "url(assets/img/product/product-7.jpg)",
              }}
            >
              <ul className="product__hover">
                <li>
                  <a
                    href="assets/img/product/product-7.jpg"
                    className="image-popup"
                  >
                    <span className="arrow_expand"></span>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <span className="icon_heart_alt"></span>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <span className="icon_bag_alt"></span>
                  </a>
                </li>
              </ul>
            </div>
            <div className="product__item__text">
              <h6>
                <a href="#">Contrasting sunglasses</a>
              </h6>
              <div className="rating">
                <i className="fa fa-star"></i>
                <i className="fa fa-star"></i>
                <i className="fa fa-star"></i>
                <i className="fa fa-star"></i>
                <i className="fa fa-star"></i>
              </div>
              <div className="product__price">$ 59.0</div>
            </div>
          </div>
        </div>
        <div className={`${(shopProduct) ? 'col-lg-4 col-md-6' : 'col-lg-3 col-md-4 col-sm-6 women men kid accessories cosmetic'}`}>
          <div className="product__item sale">
            <div
              className="product__item__pic set-bg"
              style={{
                backgroundImage: "url(assets/img/product/product-6.jpg)",
              }}
            >
              <div className="label sale">Sale</div>
              <ul className="product__hover">
                <li>
                  <a
                    href="assets/img/product/product-6.jpg"
                    className="image-popup"
                  >
                    <span className="arrow_expand"></span>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <span className="icon_heart_alt"></span>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <span className="icon_bag_alt"></span>
                  </a>
                </li>
              </ul>
            </div>
            <div className="product__item__text">
              <h6>
                <a href="#">Tropical Kimono</a>
              </h6>
              <div className="rating">
                <i className="fa fa-star"></i>
                <i className="fa fa-star"></i>
                <i className="fa fa-star"></i>
                <i className="fa fa-star"></i>
                <i className="fa fa-star"></i>
              </div>
              <div className="product__price">
                $ 49.0 <span>$ 59.0</span>
              </div>
            </div>
          </div>
        </div>
        
        <div className={`${(shopProduct) ? 'col-lg-4 col-md-6' : 'col-lg-3 col-md-4 col-sm-6 women men kid accessories cosmetic'}`}>
          <div className="product__item">
            <div
              className="product__item__pic set-bg"
              style={{
                backgroundImage: "url(assets/img/product/product-7.jpg)",
              }}
            >
              <ul className="product__hover">
                <li>
                  <a
                    href="assets/img/product/product-7.jpg"
                    className="image-popup"
                  >
                    <span className="arrow_expand"></span>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <span className="icon_heart_alt"></span>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <span className="icon_bag_alt"></span>
                  </a>
                </li>
              </ul>
            </div>
            <div className="product__item__text">
              <h6>
                <a href="#">Contrasting sunglasses</a>
              </h6>
              <div className="rating">
                <i className="fa fa-star"></i>
                <i className="fa fa-star"></i>
                <i className="fa fa-star"></i>
                <i className="fa fa-star"></i>
                <i className="fa fa-star"></i>
              </div>
              <div className="product__price">$ 59.0</div>
            </div>
          </div>
        </div>
      
        {
          shopProduct ?
            <div className={`${(shopProduct) ? 'col-lg-4 col-md-6' : 'col-lg-3 col-md-4 col-sm-6 mix women'}`}>
              <div className="product__item">
                <div
                  className="product__item__pic set-bg"
                  style={{
                    backgroundImage: "url(assets/img/product/product-1.jpg)",
                  }}
                >
                  <div className="label new">New</div>
                  <ul className="product__hover">
                    <li>
                      <a
                        href="assets/img/product/product-1.jpg"
                        className="image-popup"
                      >
                        <span className="arrow_expand"></span>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <span className="icon_heart_alt"></span>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <span className="icon_bag_alt"></span>
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="product__item__text">
                  <h6>
                    <a href="#">Buttons tweed blazer</a>
                  </h6>
                  <div className="rating">
                    <i className="fa fa-star"></i>
                    <i className="fa fa-star"></i>
                    <i className="fa fa-star"></i>
                    <i className="fa fa-star"></i>
                    <i className="fa fa-star"></i>
                  </div>
                  <div className="product__price">$ 59.0</div>
                </div>
              </div>
            </div>
            : null
        }
        {
        shopProduct ?
        <div class="col-lg-12 text-center">
          <div class="pagination__option">
            <a href="#">1</a>
            <a href="#">2</a>
            <a href="#">3</a>
            <a href="#"><i class="fa fa-angle-right"></i></a>
          </div>
        </div>
        : null
        }
      </div>
    </>
  );
}

export default WomensProduct;